import React, { ReactElement, useMemo } from 'react';
import Headshot, { HeadshotTypes } from '../Headshot/headshot';
import Image from '../Image/image';
import Icon from '../Icon/icon';
import COLORS from '../../style/universal.color';
import { FavIconContainer, SpotContainer } from './spot.style';
import { SpotProps, SpotType } from './spot.types';

const Spot = ({
  alt,
  className,
  id,
  isFavorite,
  lazyload = true,
  spotSource = HeadshotTypes.SPOTS,
  type = SpotType.TEAM,
  width,
}: SpotProps) => {
  const spotWidth: number = +width;
  const favIconWidth = Math.floor(spotWidth * 0.42);
  let spotComponent: ReactElement | null = null;

  if (type === SpotType.PLAYER) {
    spotComponent = (
      <Headshot src="" playerId={id} alt={alt} lazyload={lazyload} type={spotSource} width={spotWidth} ratio="1:1" />
    );
  } else {
    const imageType = Object.values(SpotType).includes(type) ? type : 'sport';
    const srcset = useMemo(
      () => ({
        '1x': `https://midfield.mlbstatic.com/v1/${imageType}/${id}/spots/${spotWidth}`,
        '2x': `https://midfield.mlbstatic.com/v1/${imageType}/${id}/spots/${spotWidth * 2}`,
        '3x': `https://midfield.mlbstatic.com/v1/${imageType}/${id}/spots/${spotWidth * 3}`,
      }),
      [id, imageType, spotWidth],
    );

    spotComponent = (
      <Image
        alt={alt}
        lazyload={lazyload}
        placeHolderHeight={spotWidth}
        placeHolderWidth={spotWidth}
        src={srcset['3x']}
        srcset={srcset}
      />
    );
  }

  return (
    <SpotContainer data-size={spotWidth} className={className}>
      {isFavorite && (
        <FavIconContainer data-size={favIconWidth}>
          <Icon name="favorite" fill={COLORS.favoriteYellow} width={favIconWidth} />
        </FavIconContainer>
      )}
      {spotComponent}
    </SpotContainer>
  );
};

export default Spot;
